import { Pipe, PipeTransform } from 'angular-ts-decorators';

export type PercentageIncreaseFilter = (
  input: number,
  reference: number,
) => number;

interface IPercentageIncrease {
  transform: PercentageIncreaseFilter;
}

/**
 * Returns the percentage increase between the input & reference value
 * @param {number} input current number
 * @param {number} reference reference number
 * @return {number} percentage increase
 */
@Pipe({ name: 'percentageIncrease' })
export class PercentageIncreasePipe
  implements PipeTransform, IPercentageIncrease
{
  constructor() {
    'ngInject';
  }

  public transform(input: number, reference: number): number {
    if (
      !angular.isNumber(input) ||
      !angular.isNumber(reference) ||
      reference === 0 ||
      isNaN(reference)
    ) {
      return;
    }

    return ((input - reference) / Math.abs(reference)) * 100;
  }
}
